<template>
  <svg
    width="106"
    height="106"
    viewBox="0 0 106 106"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M52.5942 5.5332V53.0541M52.5942 53.0541V100.575M52.5942 53.0541H100.115M52.5942 53.0541H5.07324"
      stroke="url(#paint0_linear_1067_6391)"
      stroke-width="10"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1067_6391"
        x1="100.115"
        y1="60.4549"
        x2="5.98543"
        y2="69.7212"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
    </defs>
  </svg>
</template>
